import React from 'react';
import styles from './LinkToBooking.styles';
import { useDispatch, useSelector } from 'react-redux';
import { CarBookingData, FleetAdminCarData } from '../../@types';
import {
  fetchBookingById,
  selectBooking,
} from '../../redux/store/userData/trips';
import {
  closeModal,
  selectSelectedDrawersCount,
} from '../../redux/store/ui/common';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

interface Props {
  text?: string;
  booking?: CarBookingData;
  params?: any;
}

const LinkToBooking: React.FC<Props> = ({ text, booking }) => {
  const dispatch = useDispatch();
  const openedDrawersCount = useSelector(selectSelectedDrawersCount);

  if (!booking) {
    return <span>{text}</span>;
  }

  const onClickHandler = (e: any) => {
    e.preventDefault();
    if (booking != null && openedDrawersCount < 2) {
      dispatch(fetchBookingById(booking.id));
    }
    // dispatch(fetchBookingById(booking.id));
    // dispatch(closeModal('ConfirmBlockModal'));
  };
  return (
    <>
      {openedDrawersCount < 2 ? (
        <span
          data-testid={`LinkToBooking-carBookingLink-${text}`}
          className="link"
          onClick={onClickHandler}
        >
          {text || '-'}
        </span>
      ) : (
        <Link
          replace={false}
          to={{
            pathname: '/dashboard',
            search: `?vm=BOOKING&type=TABLE&bookingId=${booking.id}`,
          }}
          target="_blank"
        >
          <a className="external-link-wrapper" target="_blank" rel="noreferrer">
            <span className="link">{text}</span>
            <ExportOutlined
              color="#0077be"
              style={{ fontSize: '18px', marginLeft: '10px' }}
            />
          </a>
        </Link>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToBooking;
